"use client";

import { useEffect } from "react";
import { useNotebook } from "@/lib/notebook/core/store";

const BACKGROUND_POLL_MS = 120_000;

/** Event-driven lifecycle sync — no aggressive polling while notebook is open. */
export function useNotebookLifecycleSync(notebookId, enabled) {
  useEffect(() => {
    if (!enabled || !notebookId) return undefined;

    const run = () => {
      void useNotebook.getState().syncLifecycle();
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible") run();
    };

    run();
    window.addEventListener("focus", run);
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("inora:trash-changed", run);

    const interval = window.setInterval(() => {
      if (document.visibilityState === "visible") run();
    }, BACKGROUND_POLL_MS);

    return () => {
      window.removeEventListener("focus", run);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("inora:trash-changed", run);
      window.clearInterval(interval);
    };
  }, [enabled, notebookId]);
}
